import { API } from '../helpers/fetcher'

export const bancontactAuthentication = async params =>
  API.post('v1/transaction/bancontact/authenticate', params)

export const adyenBancontactAuthentication = async params =>
  API.post('v1/transaction/adyen/bancontact/authenticate', params)

export const adyenBancontactCancel = async transactionId =>
  API.post(`v1/transaction/adyen/bancontact/${transactionId}/cancel`)
